import axios from 'axios';
import Url from '../constants/Url';

class DashboardApi {
    getProducts(params?) {
        const {version} = params || {};
        return axios
            .get(Url(version).GET_PRODUCTS, {params})
            .then(response => response.data)
            .catch(ex => {
                console.error('Failed to getProducts:', ex.message);
                throw ex;
            });
    }

    getEarnedProducts(params?) {
        const {version} = params || {};
        return axios
            .get(Url(version).GET_EARNED_PRODUCTS, {params})
            .then(response => response.data)
            .catch(ex => {
                console.error('Failed to getEarnedProducts:', ex.message);
                throw ex;
            });
    }

    getEarningsData(params?) {
        const {version} = params || {};
        return axios
            .get(Url(version).GET_EARNINGS_DATA, {params})
            .then(response => response.data)
            .catch(ex => {
                console.error('Failed to getEarningsData:', ex.message);
                throw ex;
            });
    }
}

export default new DashboardApi();
